import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    Trustpilot: { loadFromElement: (arg0: null, arg1: boolean) => void }
  }
}

const TrustPilotMicroStar = (): JSX.Element => {
  const ref = useRef(null)

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id="6304e8f191601441fb809a43"
      data-style-height="24px"
      data-style-width="100%"
      data-disable-link="true"
      data-token="aeb40400-d95a-4450-8043-ad802e6c9010"
      data-test="trustpilot-micro-star"
    >
      <span>Trustpilot</span>
    </div>
  )
}

export default TrustPilotMicroStar
